export const trackEvent = (eventName: string, params?: Record<string, any>): void => {
  if (typeof window === 'undefined') return;
  if (!(window as any).gtag) return;
  (window as any).gtag('event', eventName, params);
};

export const trackPageView = (path: string): void => {
  trackEvent('page_view', { page_path: path });
};

// GTM handles initialization via the snippet in public/index.html.
// Kept for API compatibility so no component changes are needed.
export const initGA = (): void => {};

export const isGAInitialized = (): boolean => {
  return !!(typeof window !== 'undefined' && (window as any).dataLayer);
};
